/**
 * Daqiqani «4 s 12 daq» shakliga aylantiradi (kanvas shakli).
 *
 * ⚠️ **`modules/reports` dagi `formatReportCell` QAYTA ISHLATILMAYDI**
 * (`ReportTable.tsx`): u `4:12` shaklini beradi va
 * `packages/core/src/export/writer.ts` dagi `formatDuration` bilan
 * AYNAN mos bo'lishi shart — panel va Excel manfiy qiymatda
 * ajralmasligi uchun. UI matni uchun o'sha formulani o'zgartirish ikki
 * iste'molchini ajratardi; qo'shni moduldan import qilish esa
 * `modules/employees` ni `modules/reports` ga bog'lardi (`summary.ts`
 * da bu naqsh ataylab rad etilgan).
 *
 * ⚠️⚠️ **Ishora OLDIN ajratiladi.** `Math.floor(-90 / 60)` = `-2`,
 * `Math.abs(-90 % 60)` = `30`, ya'ni sodda formula belgini IKKI MARTA
 * hisoblab «-2 s 30 daq» berardi — to'g'risi «-1 s 30 daq». Natija
 * ISHONARLI ko'rinadi, ya'ni xato JIM. Aynan shu nuqson poydevor
 * bosqichida eksport tomonida topilgan (`ReportTable.tsx`), naqsh
 * takrorlanadi.
 *
 * ⚠️ Bir soatdan kam bo'lsa soat qismi UMUMAN chizilmaydi — «0 s 12
 * daq» o'quvchini soatga qaratib, kichik qiymatni kattaroq
 * ko'rsatardi. Butun soatda esa daqiqa qismi chizilmaydi.
 */
export function soatDaqiqa(daqiqa: number): string {
	// ⚠️ `NaN`/`Infinity` — «Jami NaN daq tashqarida» o'rniga «—».
	if (!Number.isFinite(daqiqa)) {
		return "—";
	}

	const manfiy = daqiqa < 0;
	const mutlaq = Math.abs(Math.round(daqiqa));
	const soat = Math.floor(mutlaq / 60);
	const qoldiq = mutlaq % 60;
	const belgi = manfiy ? "-" : "";

	if (soat === 0) {
		return `${belgi}${qoldiq} daq`;
	}

	return qoldiq === 0 ? `${belgi}${soat} s` : `${belgi}${soat} s ${qoldiq} daq`;
}
